//TODO: update with yours
export interface InteractionConfig {
	picSrc: string;
	sender: string;
	prompt: string;
	name: string;
	preRotateMS?: number;
	postRotateMS?: number;
	TTSNarrationURL: string;
}

//TODO: update with yours
export function validateConfig(c: InteractionConfig): boolean {
	if (!c) {
		return false;
	}
	if (!c.picSrc) {
		return false;
	}
	if (!c.preRotateMS) {
		c.preRotateMS = 4000
	}
	if (!c.postRotateMS) {
		c.postRotateMS = 11000
	}
	return true;
}
